import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ymHit } from '../components/common';
import Content from '../components/mplat/Content';
import ContentShadow from '../components/mplat/ContentShadow';
import Section from '../components/mplat/Section';
import PromoImage from '../img/Mediabaza_680x280px.png';


function HelpPage() {
    const { t } = useTranslation();

    useEffect(() => ymHit('/legal'), []);

    useEffect(() => {
        document.title = t('Legal');
    }, [t]);

    return (
        <Content style={{maxWidth: '760px'}}>
            <ContentShadow />

            <Section label={undefined} >
                <h1 style={{ textAlign: 'center' }}>Маркетплейс контента «Медиабаза» поддерживает новые телеканалы</h1>


                <div>
                    <img src={PromoImage} width={'100%'} style={{ maxWidth: '680px' }} />
                </div>
                <div style={{textAlign: 'justify'}}>
                <p>
                    <Link to="/" className={'link-accent'}>«Медиабаза»</Link> поддерживает новые телеканалы  и предлагает операторам льготные условие на их подключение.
                </p>
                <p>
                    При заказе в апреле 2025 года телеканала Viju TV1000 Романтика на нашем маркетплейсе <Link to="/" className={'link-accent'}>mediabaza.ru</Link> предоставляется бесплатно доставка этого телеканала через платформу Медиалогистика в течение 12 месяцев.
                </p>
                <p>
                    <a className={'link-accent'} href="https://www.msk-ix.ru/special_offers/mediabaza/">Подробные правила акции</a>
                </p>
                </div>
            </Section>
        </Content>
    )
}

export default HelpPage;
